<template>
  <div class="Others21Charts">
    <Teleport to="body">
      <div v-if="enabled && showWarningTip" class="warning-tip" :style="warningTipStyle">
        累计出现{{ warningItemValue }}条{{ warningItemName }}数据 ，请前往
        <a :href="link" target="_blank" rel="noopener noreferrer">{{ linkName }}</a> 查看并处理
      </div>
    </Teleport>
    <div
      class="o_21_item"
      :style="{
        width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
        height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        marginTop: `${$w_Ratio(9 + getShowfontSizeBase(), $store)}px`,
        marginLeft: `calc((100% - ${$w_Ratio(150 + getShowfontSizeBase(), $store)}px * 2) / 3)`,
      }"
    >
      <div
        class="o_21_item_value"
        :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
        }"
      >
        {{ dataSet.source[0] ? dataSet.source[0].y || 0 : 0 }}
      </div>
      <div
        class="o_21_item_icon"
        :style="{
          width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="@/assets/img/Others21Charts/001.png" />
      </div>
      <div
        class="o_21_item_label"
        :style="{
          fontSize: `${fontStyle.yAxisSize}px`,
        }"
      >
        {{ dataSet.source[0] ? dataSet.source[0].x || '今日舆情统计' : '今日舆情统计' }}
      </div>
    </div>

    <div
      class="o_21_item"
      :style="{
        width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
        height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        marginTop: `${$w_Ratio(9 + getShowfontSizeBase(), $store)}px`,
        marginLeft: `calc((100% - ${$w_Ratio(150 + getShowfontSizeBase(), $store)}px * 2) / 3)`,
      }"
    >
      <div
        class="o_21_item_value"
        :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
        }"
      >
        {{ dataSet.source[1] ? dataSet.source[1].y || 0 : 0 }}
      </div>
      <div
        class="o_21_item_icon"
        :style="{
          width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="@/assets/img/Others21Charts/001.png" />
      </div>
      <div
        class="o_21_item_label"
        :style="{
          fontSize: `${fontStyle.yAxisSize}px`,
        }"
      >
        {{ dataSet.source[1] ? dataSet.source[1].x || '今日舆情统计' : '今日舆情统计' }}
      </div>
    </div>

    <div
      class="o_21_item"
      :style="{
        width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
        height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        marginTop: `${$w_Ratio(9 + getShowfontSizeBase(), $store)}px`,
        marginLeft: `calc((100% - ${$w_Ratio(150 + getShowfontSizeBase(), $store)}px * 2) / 3)`,
      }"
    >
      <div
        :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
        }"
        class="o_21_item_value"
      >
        {{ dataSet.source[2] ? dataSet.source[2].y || 0 : 0 }}
      </div>
      <div
        class="o_21_item_icon"
        :style="{
          width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="@/assets/img/Others21Charts/001.png" />
      </div>
      <div
        class="o_21_item_label"
        :style="{
          fontSize: `${fontStyle.yAxisSize}px`,
        }"
      >
        {{ dataSet.source[2] ? dataSet.source[2].x || '今日舆情统计' : '今日舆情统计' }}
      </div>
    </div>

    <div
      class="o_21_item"
      :style="{
        width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
        height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        marginTop: `${$w_Ratio(9 + getShowfontSizeBase(), $store)}px`,
        marginLeft: `calc((100% - ${$w_Ratio(150 + getShowfontSizeBase(), $store)}px * 2) / 3)`,
      }"
    >
      <div
        class="o_21_item_value"
        :style="{
          fontSize: `${fontStyle.xAxisSize}px`,
        }"
      >
        {{ dataSet.source[3] ? dataSet.source[3].y || 0 : 0 }}
      </div>
      <div
        class="o_21_item_icon"
        :style="{
          width: `${$w_Ratio(150 + getShowfontSizeBase(), $store)}px`,
          height: `${$w_Ratio(100 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <img src="@/assets/img/Others21Charts/001.png" />
      </div>
      <div
        class="o_21_item_label"
        :style="{
          fontSize: `${fontStyle.yAxisSize}px`,
        }"
      >
        {{ dataSet.source[3] ? dataSet.source[3].x || '今日舆情统计' : '今日舆情统计' }}
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../../../common/request';

export default {
  name: 'Others21Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      debounce_subscribeConfigurationChange: null, // 订阅Configuration变化的防抖函数
      apiIntervalTaskID: null, // api任务的定时器ID
      staticIntervalTaskID: null, // 静态任务的定时器ID
      noData: false, // 是否没有数据
      fontStyle: {},
      dataSet: {
        seriesList: [],
        source: [],
      },
      enabled: false,
      threshold: 10,
      itemName: '负面',
      link: '',
      linkName: '',
      screenDomRect: null, // screen-dom元素的位置信息
    };
  },
  computed: {
    warningItemName() {
      return this.itemName;
    },
    warningItemValue() {
      let item = this.dataSet.source && this.dataSet.source.find(i => i.x === this.warningItemName);
      return (item && item.y) || 0;
    },
    showWarningTip() {
      let config =
        this.Configuration &&
        this.Configuration.propertyData &&
        this.Configuration.propertyData.showWarningTip &&
        this.Configuration.propertyData.showWarningTip.value;
      if (!config || !config.enabled) return false;
      let threshold = config.threshold !== undefined && config.threshold !== null ? config.threshold : 10;
      return this.warningItemValue > threshold;
    },
    warningTipStyle() {
      console.log(this.screenDomRect, 'screenDomRect');
      if (!this.screenDomRect) {
        return {
          position: 'fixed',
          top: '0',
          left: '0',
        };
      }
      return {
        position: 'fixed',
        top: `${this.screenDomRect.top + this.$w_Ratio(26 + this.getShowfontSizeBase(), this.$store)}px`,
        left: `${this.screenDomRect.right - this.$w_Ratio(630 + this.getShowfontSizeBase(), this.$store)}px`,
      };
    },
  },
  created() {
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.startApiIntervalTask();
    this.startStaticIntervalTask();
    // 替换 ?? 为 ||
    this.enabled = this.Configuration.propertyData?.showWarningTip?.value?.enabled || false;
    this.threshold = this.Configuration.propertyData?.showWarningTip?.value?.threshold || 10;
    this.itemName = this.Configuration.propertyData?.showWarningTip?.value?.itemName || '负面';
    this.link = this.Configuration.propertyData?.showWarningTip?.value?.link || '';
    this.linkName = this.Configuration.propertyData?.showWarningTip?.value?.linkName || '实时舆情监测系统';
    this.updateScreenDomRect();
    window.addEventListener('scroll', this.updateScreenDomRect, true);
    window.addEventListener('resize', this.updateScreenDomRect);
  },
  methods: {
    updateScreenDomRect() {
      console.log('1111111111');

      const screenDom = document.getElementById('screen-dom');
      if (screenDom) {
        this.screenDomRect = screenDom.getBoundingClientRect();
      }
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearTimeout(this.apiIntervalTaskID);
      clearTimeout(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },

    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      clearTimeout(this.apiIntervalTaskID);

      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      console.log('startApiIntervalTask:>>>>', ChartsData?.apiData?.isUseInterval);

      if (ChartsData?.currenEntry !== 'apiData') return;

      this.getApiDataResByFilterAndResponseQuery()
        .then(this.setEchartsOptions)
        .catch(err =>
          console.log('startApiIntervalTask-getApiDataResByFilterAndResponseQuery failed:>>>>', err),
        )
        .finally(() => {
          if (ChartsData?.apiData?.isUseInterval) {
            console.log('开启 interval 任务，间隔请求');
            this.apiIntervalTaskID = setTimeout(
              () => this.startApiIntervalTask(),
              ChartsData?.apiData?.apiInterval * 1000,
            );
          }
        });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;

      if (ChartsData?.currenEntry !== 'staticData') return;

      if (chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let data = this.$_.cloneDeep(ChartsData.staticData);
        data.source.forEach(item => (item.y = 0));
        this.setEchartsOptions(data);
        setTimeout(() => this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData)), 0);

        this.staticIntervalTaskID = setTimeout(
          () => this.startStaticIntervalTask(),
          chartsAnimation?.staticRefreshIntervalTime * 1000,
        );
      } else {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');

        this.getApiDataRes()
          .then(res => {
            // query数据
            let keys = ChartsData.apiData.apiResponseQuery.split('.');
            if (keys.length) {
              console.log('keys:>>>>', keys);
              keys.forEach(key => (res = res[key]));
            }

            let result = null;

            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              result = this.run_script(ChartsData.apiData.apiFilter, res);
            } else {
              result = res;
            }

            resolve(result);
          })
          .catch(reject);
      });
    },
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');

        let param = {
          method: ChartsData.apiData.apiUrlMethod,
          url: ChartsData.apiData.apiUrl,
          params: {},
        };

        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          // 替换 ?? 为 ||
          if (user_key == 'undefined' || user_key == 'null' || user_key == null)
            user_key = this.$userKey || '';
          param['headers'] = { userkey: user_key };
        }

        request(param)
          .then(resolve)
          .catch(reject);
      });
    },

    setEchartsOptions(data = null) {
      this.fontStyle = {};
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.fontStyle.value) {
        this.fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      if (!data) return (this.noData = true);
      this.dataSet = data;
    },

    /**
     * 运行脚本
     * @param {string} script 脚本
     * @param {*} data 数据
     */
    run_script(script, data) {
      let dataSet = {};
      try {
        eval(script);
      } catch (error) {
        console.error('run_script failed: ', error);
      }
      return dataSet;
    },
  },
  beforeUnmount() {
    clearTimeout(this.apiIntervalTaskID);
    clearTimeout(this.staticIntervalTaskID);
    this.unRegisterDebounceAndThrottle();
    window.removeEventListener('scroll', this.updateScreenDomRect, true);
    window.removeEventListener('resize', this.updateScreenDomRect);
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function(val) {
        console.log('Configuration:>>>>', val);
        // 替换 ?? 为 ||
        this.enabled = val.propertyData.showWarningTip.value.enabled || false;
        this.threshold = val.propertyData.showWarningTip.value.threshold || 10;
        this.itemName = val.propertyData.showWarningTip.value.itemName || '负面';
        this.link = val.propertyData.showWarningTip.value.link || '';
        this.linkName = val.propertyData.showWarningTip.value.linkName || '实时舆情监测系统';
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  Configuration: {
    componentTitle: '双行分组组件',
    componentName: 'Others21Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others21Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['舆情数'],
            source: [
              {
                s: '舆情数',
                x: '舆情数A',
                y: 100,
              },
              {
                s: '舆情数',
                x: '舆情数B',
                y: 10,
              },
              {
                s: '舆情数',
                x: '舆情数C',
                y: 200,
              },
              {
                s: '舆情数',
                x: '舆情数D',
                y: 22,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      textComponentUnits: {
        propertyComponentName: 'MapTextConfiger',
        value: '元',
      },
      showWarningTip: {
        value: {
          enabled: false,
          enabledLabel: '启用提示',
          itemName: '负面',
          itemNameLabel: '提示名称',
          threshold: 10,
          thresholdLabel: '设置阈值',
          linkLabel: '跳转链接',
          link: '',
          linkName: '实时舆情监测系统',
        },
        lable: '提示文字配置',
        propertyComponentName: 'SingleInputor',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.Others21Charts {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
  height: 100%;
  .o_21_item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* width: 174px; */
    /* height: 100px;  */
    /* margin-left: calc((100% - 174px * 2) / 3); */
    /* margin-top: 40px;  */
    .o_21_item_value {
      z-index: -1;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      /* font-size: 20px; */
      color: #fff;
      text-wrap: nowrap;
    }
    .o_21_item_icon {
      display: flex;
      /* width: 174px;
      height: 100px; */
      img {
        width: 100%;
        height: 100%;
      }
    }
    .o_21_item_label {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      text-wrap: nowrap;
      /* font-size: 14px; */
      color: #fff;
    }
  }
}
</style>

<style lang="scss">
.warning-tip {
  position: fixed;
  z-index: 99999;
  color: #fff;
  padding: 8px 12px;
}
.warning-tip a {
  color: #fff;
}
</style>
